import { type GoalGroup } from '@fruitful/types';
import { GoalStatus } from '@fruitful/types';
import { router, useLocalSearchParams } from 'expo-router';
import { useAtomValue, useSetAtom } from 'jotai';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect } from 'react';

import { adminUserAtom, isEditingGoalsAtom } from '../../../entityAtoms';
import { type GoalCategory } from '../../../entityTypes';
import { GoalsRenderer } from './Goals';

export const MembershipGoalsInfo = ({
    goalGroups,
    goalCategories,
}: {
    goalGroups: GoalGroup[];
    goalCategories: GoalCategory[];
}) => {
    const { gt: selectedTabIndex } = useLocalSearchParams<{ gt: string }>();
    const adminUser = useAtomValue(adminUserAtom);
    const canEditGoals =
        adminUser.authorization.selectedMembership.goals.canEdit;
    const setIsEditingGoalsAtom = useSetAtom(isEditingGoalsAtom);

    useEffect(() => {
        setIsEditingGoalsAtom(canEditGoals);
        return () => {
            setIsEditingGoalsAtom(false);
        };
    }, [canEditGoals]);

    return (
        <TabView
            style={{ width: '100%' }}
            panelContainerStyle={{
                width: '100%',
                padding: 0,
                marginTop: 32,
            }}
            activeIndex={parseInt(selectedTabIndex, 10) || 0}
            onTabChange={(e) => {
                router.setParams({ gt: e.index.toString() });
            }}
        >
            <TabPanel header="Active Goals">
                <GoalsRenderer
                    goalGroups={goalGroups}
                    goalCategories={goalCategories}
                    status={GoalStatus.IN_PROGRESS}
                />
            </TabPanel>
            <TabPanel header="Drafts">
                <GoalsRenderer
                    goalGroups={goalGroups}
                    goalCategories={goalCategories}
                    status={GoalStatus.DRAFT}
                />
            </TabPanel>
            <TabPanel header="Completed">
                <GoalsRenderer
                    goalGroups={goalGroups}
                    goalCategories={goalCategories}
                    status={GoalStatus.COMPLETE}
                />
            </TabPanel>
            <TabPanel header="Archived">
                <GoalsRenderer
                    goalGroups={goalGroups}
                    goalCategories={goalCategories}
                    status={GoalStatus.DELETED}
                />
            </TabPanel>
        </TabView>
    );
};
